var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbank46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 0H0V46H46V0Z",
    fill: "#120063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1832 32.9468H14.7921L12.5895 35.4972V32.9468H11.4766V38.5113H12.5895V35.9609L14.8616 38.5113H16.2528L13.7719 35.729L16.1832 32.9468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9194 34.5234C18.4557 34.5234 18.0615 34.7321 17.7369 35.0103V32.9468H16.624V36.6101C16.624 37.723 17.366 38.6504 18.7339 38.6504C19.9627 38.6504 20.8438 37.7925 20.8438 36.6101C20.8206 35.474 20.0787 34.5234 18.9194 34.5234ZM18.7107 37.6534C18.1311 37.6534 17.6674 37.1897 17.6674 36.6333V36.6101C17.6674 36.4942 17.6906 36.3782 17.7137 36.2623C17.8529 35.845 18.247 35.5436 18.7107 35.5436C19.2904 35.5436 19.7541 36.0073 19.7541 36.5869C19.7541 37.1665 19.2904 37.6534 18.7107 37.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6567 34.5229C28.1234 34.5229 27.7061 34.7084 27.3815 35.0098V34.6389H26.2686V37.4907V38.5109H27.3583H27.3815V36.3314C27.3815 35.8909 27.7524 35.5199 28.1929 35.5199C28.6335 35.5199 29.0044 35.8909 29.0044 36.3314V38.4877V38.5109H30.1173V36.03C30.1173 36.0068 30.1173 36.0068 30.1173 35.9836C30.1405 35.1721 29.4681 34.5229 28.6567 34.5229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4631 34.5229C22.2111 34.5229 21.3301 35.3808 21.3301 36.5633C21.3301 37.6994 22.0952 38.6268 23.2545 38.6268C23.7877 38.6268 24.2978 38.3486 24.576 37.9544V38.4877H25.573V36.5401C25.573 36.5169 25.573 36.5169 25.573 36.5169C25.5962 35.4504 24.8543 34.5229 23.4631 34.5229ZM23.4863 37.6298C22.9067 37.6298 22.443 37.1661 22.443 36.5865C22.443 36.0068 22.9067 35.5431 23.4863 35.5431C24.066 35.5431 24.5297 36.0068 24.5297 36.5865C24.5529 37.1661 24.0892 37.6298 23.4863 37.6298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5226 38.4647L32.8533 36.5403L34.4763 34.6391H33.2706L31.8795 36.2852V32.9233H30.7666V38.4647H31.8795V36.7953L33.317 38.4647H34.5226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8629 10.897L23 16.1369L16.1371 10.897L11.5 7.34961V13.0069V29.7236H16.1371V16.6006L23 21.9333L29.8629 16.6006V29.7236H34.5V13.0069V7.34961L29.8629 10.897Z",
    fill: "#BCF100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbank46);
export default __webpack_public_path__ + "static/media/Kbank-46.a82a73c5a04715594ca188202636b21a.svg";
export { ForwardRef as ReactComponent };